import Reveal from "@/components/base/Reveal";

const subtitleTypes = [
  {
    name: "直译字幕",
    best: "想理解原文语气",
    detail: "尽量贴近原句结构与称谓，信息完整，偶尔读起来略生硬，但更少丢失人物关系线索。",
  },
  {
    name: "意译字幕",
    best: "想顺畅看懂剧情",
    detail: "把俚语和隐喻换成中文习惯说法，读起来轻松，代价是部分双关与语气会被抹平。",
  },
  {
    name: "双语字幕",
    best: "想对照着学",
    detail: "上下两行同时呈现，适合边看边对照原文，但屏幕上文字更多，需要更大的显示尺寸。",
  },
];

const checklist = [
  "播放前先确认字幕与画面时间轴是否对齐，错位会直接影响对白理解。",
  "人物称谓（Mr./Ms.、亲密称呼）译法是否统一，它是判断关系亲疏的线索。",
  "长镜头里的画外对白是否也配了字幕，漏译常发生在这里。",
  "名词与人名前后是否一致，反复出现的译名不统一会让人物变得混乱。",
];

export default function SubtitleSection() {
  return (
    <section id="subtitle" className="py-16 md:py-24 bg-background-100 border-y border-background-200">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <Reveal className="lg:col-span-5">
            <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">Subtitle & HD</span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              中字、中文字幕与高清：<br />为什么它们决定了观感
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              这类电影的对白密度高、语气细微，很多信息不在剧情里，而在“怎么说”上。字幕翻得准不准、
              画质够不够清晰，直接决定了你能不能读到人物的情绪变化。
            </p>

            <div className="mt-6 rounded-lg bg-accent-50 border border-accent-200 p-5">
              <div className="flex items-center gap-2 text-accent-900">
                <i className="ri-checkbox-circle-line text-xl"></i>
                <h3 className="font-heading text-base font-semibold">观影前检查清单</h3>
              </div>
              <ul className="mt-3 space-y-2.5">
                {checklist.map((c, i) => (
                  <li key={i} className="flex gap-2.5 text-sm leading-relaxed text-foreground-700">
                    <span className="font-label text-accent-700 font-semibold shrink-0">{i + 1}.</span>
                    <span>{c}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <div className="lg:col-span-7 space-y-4">
            {subtitleTypes.map((t, i) => (
              <Reveal key={t.name} delay={i * 80}>
                <article className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 flex flex-col sm:flex-row gap-4 sm:items-center">
                  <div className="sm:w-40 shrink-0">
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{t.name}</h3>
                    <span className="inline-block mt-2 px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs">
                      {t.best}
                    </span>
                  </div>
                  <p className="text-sm leading-relaxed text-foreground-600 sm:border-l sm:border-background-200 sm:pl-5">
                    {t.detail}
                  </p>
                </article>
              </Reveal>
            ))}

            <Reveal delay={240}>
              <div className="rounded-lg bg-foreground-950 p-5 md:p-6">
                <div className="flex items-center gap-2 text-background-50">
                  <i className="ri-hd-line text-xl"></i>
                  <h3 className="font-heading text-base md:text-lg font-semibold">关于“高清”的实用建议</h3>
                </div>
                <p className="mt-3 text-sm leading-relaxed text-background-200">
                  分辨率越高，暗部细节越完整——而这类电影恰恰大量使用室内弱光与自然光。若片源压缩过度，
                  夜戏会糊成一片，表演的细微停顿也就看不到了。优先选择画面稳定的版本，比一味追求高码率更实际。
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}